//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertErrorNotify from "components/DialogAlertNotify/DialogAlertErrorNotify/DialogAlertErrorNotify";
//#endregion
//#region Images
import errorImage1 from "img/error_image_1.svg";
//#endregion

const DialogAlertErrorSimple = ({
    dialogShow, title, content
}) => {
    return (
        <DialogAlertErrorNotify 
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}
            content={{
                value: content,
                title: title,
                image: <img src={errorImage1} alt="Error"/>,
                widthParagraph: "90%"
            }}>
            <CustomButton 
                text="Cerrar"
                width="85px"
                onClick={() => dialogShow.toggle()}/>
        </DialogAlertErrorNotify>
    );
}

export default DialogAlertErrorSimple;